import React, { useContext } from "react";
import { ConfirmDialog, useNotifications } from "sprint-common-web";

import { useOnPremOrdersApi } from "../../../../../common/api/orders-api/useOnPremOrdersApi";
import { OrderRequestStatus } from "../../../../../common/types/OrderRequestStatus";
import { OrderRequestListingContext } from "../../context/OrderRequestListingContext";
import { OrderRequestListingItem } from "../../OrderRequestListingItem";

type SendOrderRequestToOnPremDialogProps = { item: OrderRequestListingItem; isOpen: boolean; onClose(): void };

export const SendOrderRequestToOnPremDialog: React.VFC<SendOrderRequestToOnPremDialogProps> = ({
    item,
    isOpen,
    onClose
}: SendOrderRequestToOnPremDialogProps) => {
    const { success, error } = useNotifications();
    const { createOnPremOrderFromRequest } = useOnPremOrdersApi();
    const { markAsChanged, updateOrderRequest } = useContext(OrderRequestListingContext);

    const sendToOnPrem = async () => {
        await createOnPremOrderFromRequest({ orderRequestId: item.id })
            .then(() => {
                markAsChanged(item.id);
                updateOrderRequest({ id: item.id, status: OrderRequestStatus.OnPremProcessing });
                success("Order request sent to on-prem successfully");
            })
            .catch(() => {
                error("Order request not sent to on-prem, please try again");
            })
            .finally(() => onClose());
    };

    return (
        <ConfirmDialog
            title="Send order request to on-prem"
            text="Are you sure you want to send this order request to on-prem? This action is irreversible."
            hidden={!isOpen}
            confirm={{ onClick: sendToOnPrem }}
            cancel={{ onClick: onClose }}
        />
    );
};
